module.exports = __webpack_public_path__ + "img/icon_round_check.a5149c5f.svg";